const SCHEDULES = {
  getSchedules: "/api/v1/schedules",
  putSchedulesDone: "/api/v1/schedules/{id}/done",
};
export default SCHEDULES;
